import { createContext, useContext, useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, getUnitId, setUnitId } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const UnitCtx = createContext(null);

export function UnitProvider({ children }) {
  const { user } = useAuth();
  const qc = useQueryClient();
  const [unitId, setId] = useState(getUnitId());
  const { data: units = [], isLoading } = useQuery({ queryKey: ["units"], queryFn: () => api("/units"), enabled: !!user });

  useEffect(() => {
    if (!units.length) return;
    if (!units.find((u) => u.id === unitId)) {
      setUnitId(units[0].id);
      setId(units[0].id);
    }
  }, [units, unitId]);

  const selectUnit = (id) => {
    setUnitId(id);
    setId(id);
    qc.invalidateQueries({ predicate: (q) => q.queryKey[0] !== "units" && q.queryKey[0] !== "layout" });
  };

  const unit = units.find((u) => u.id === unitId) || units[0];
  const ready = !user || (!isLoading && (!units.length || unit?.id === getUnitId()));
  return <UnitCtx.Provider value={{ unit, units, selectUnit, ready, loading: isLoading }}>{children}</UnitCtx.Provider>;
}

export const useUnit = () => useContext(UnitCtx);
